module.exports = __webpack_public_path__ + "staticesp/media/marcas (2).9255b50f.png";